<template>
  <div class="footer" ref="footerRef">
    <div class="logo"></div>
    <div class="menu">
      <div :class="!currentPage?'current':''">
        <a v-if="currentLang === 'en'" href="/home">{{ txtHome }}</a>
        <a v-if="currentLang === 'cn'" href="/cn/home">{{ txtHome }}</a>
      </div>
      <div :class="currentPage === 'Product'?'current':''"><a
          @click="navTo(currentPage,'home','#products',currentLang)">{{ txtProducts }}</a>
      </div>
      <div :class="currentPage === 'Contact'?'current':''"><a @click="navTo(currentPage,'home','#contact',currentLang)">{{
          txtContact
        }}</a>
      </div>
      <div :class="currentPage === 'Purchase'?'current':''"><a
          @click="navTo(currentPage,currentPage,'#purchase',currentLang)">{{ txtPurchase }}</a>
      </div>
    </div>
    <div class="copyright">
      @2024 All Right Reserved.
    </div>
  </div>
</template>
<script>
import {minxin} from "@/utils/minxin";

export default {
  props: ["currentLang", "currentPage"],
  mixins: [minxin],
  data() {
    return {
      txtHome: 'Home',
      txtProducts: 'Products',
      txtContact: 'Contact',
      txtPurchase: 'Purchase',
    };
  },
  created() {
    // const that = this;
  },
  computed: {},
  methods: {},
  mounted() {
    // const that = this;
    if ('cn' === this.currentLang) {
      this.txtHome = '首页';
      this.txtProducts = '产品';
      this.txtContact = '联系';
      this.txtPurchase = '购买';
    }
  },
};
</script>
<style lang="less" scoped>

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 220px;
  width: 100%;
  background-color: #fff;

  .logo {
    width: 90px;
    height: 90px;
    background: url("../assets/imgs/logo.jpg");
    background-size: 90px 90px;
  }

  .menu {
    width: 240px;
    display: inline-flex;
    justify-content: space-between;
    padding-bottom: 25px;
    padding-top: 20px;

    div {
      //padding-left: 10px;
      font-size: 14px;
    }

    div:first-child {
      padding-left: 0px;
    }

    div:last-child {
      padding-right: 0px;
    }

    div.current {
      color: #d5bb8e;

      a {
        color: #d5bb8e;
      }
    }

    a:link {
      color: #2c3e50;
      text-decoration: none;
    }

    a:visited {
      color: #2c3e50;
    }

    a:hover {
      color: #d5bb8e;
      cursor: pointer;
    }
  }

  .copyright {
    width: 80%;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 14px;
    text-align: center;
    border-top: 1px solid #ebeff1;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 1440px) {
  .footer {

    .logo {
      width: 100px;
      height: 100px;
      background: url("../assets/imgs/logo.jpg");
      background-size: 100px 100px;
    }

    .menu {
      width: 250px;

      div {
        //padding-left: 10px;
        font-size: 16px;
      }
    }

    .copyright {
      font-size: 16px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .footer {
    height: 320px;

    .logo {
      width: 160px;
      height: 160px;
      background: url("../assets/imgs/logo.jpg");
      background-size: 160px 160px;
    }

    .menu {
      width: 22%;

      div {
        font-size: 22px;
      }
    }

    .copyright {
      font-size: 22px;
    }
  }
}

@media only screen and (max-width: 820px) {
  .footer {
    height: 520px;

    .logo {
      width: 300px;
      height: 300px;
      background: url("../assets/imgs/logo.jpg");
      background-size: 300px 300px;
    }

    .menu {
      width: 48%;

      div {
        font-size: 48px;
      }
    }

    .copyright {
      font-size: 42px;
    }
  }
}
</style>
